<template>
  <div>
    <onaydialog ref="onaydialog"></onaydialog>


    <v-dialog scrollable="" persistent v-model="dialog" max-width="550px">
      <v-card flat color="grey lighten-3">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">  {{ $t('Reservation-Attachments') }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-text-field solo hide-details ref="ara" autofocus v-model="secilendeger" :label="$t('Please-enter-3-letters')"
            append-icon="search"></v-text-field> -->
        </v-toolbar>
        <v-card-text>

          <v-flex pb-2 xs12 sm12 md12>
            <v-card flat class="white--text">
              <v-card color="white" flat="">
                <v-card-actions>

                  <v-layout justify-space-between column>

                    <v-layout row="" wrap="">
                      <v-form ref="formek" v-model="valid" lazy-validation>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-icon medium="" color="grey">add</v-icon> &nbsp;
                              <span class=" font-weight-regular grey--text title"> {{ $t('Add-New-Reservation-Attachment') }} </span>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm4 md8>
                              <v-autocomplete hide-details="" clearable append-icon="search" :label="$t('Seller-Code')"
                                :loading="loadingsatici" :rules="[v => !!v || $t('Please-Select-Seller-Code')]"
                                v-model="RezervasyonInput.EkliSaticiKod" :items="statesatici" item-text="Aciklama"
                                item-value="Kod" :search-input.sync="searchsatici" cache-items=""></v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm4 md2>

                              <yuzdeinput :etiket="'KDV'" :rules="[v => !!v || $t('Enter-VAT-between')]"
                                v-model="RezervasyonInput.KDV" :autocomplete="'autocomplete'"></yuzdeinput>
                            </v-flex>
                            <v-flex xs12 pt-2 sm4 md2>
                              <v-btn v-if="islem=='yeni'" flat @click="rezervasyonekiEkle()" color="info">Yeni Ekle
                              </v-btn>
                               <v-btn v-if="islem=='guncelle'" flat @click="rezervasyonekiGuncelle()" color="info">
                                {{ $t('Update') }}</v-btn>

                            </v-flex>

                          </v-layout>
                        </v-flex>
                      </v-form>

                    </v-layout>


                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <div v-if="islem=='yeni'" class="flex md12">
            <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions class="elevation-1">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr item>
                  <td class="text-xs-left">{{ props.item.Satici.kod }}</td>
                  <td class="text-xs-left">{{ props.item.KDV }}</td>
                  <td class="justify-center layout px-0">
                    <v-tooltip bottom>
                      <v-btn icon small slot="activator" flat @click="rezervasyonsil(props.item)">
                        <v-icon small color="red">delete</v-icon>
                      </v-btn>
                      <span> {{ $t('Delete') }} </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn icon small slot="activator" flat @click="Getir(props.item)">
                        <v-icon small color="green">edit</v-icon>
                      </v-btn>
                      <span> {{ $t('Edit') }} </span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="islem=='yeni'" color="primary" flat @click="dialog = false">
            {{$t('Close')}} </v-btn>
            <v-btn v-if="islem=='guncelle'" flat @click="islemiptal()" color="info">
                            {{ $t('Cancel-Process') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tool from "../../coper/tools"
  import yuzdeinput from '../../customcomp/yuzdeinput'
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"


  export default {

    props: ["value"],
    components: {
      yuzdeinput,
      onaydialog
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      islemiptal(){
        this.islem='yeni'
        this.RezervasyonInput.KDV=0
        this.RezervasyonInput.EkliSaticiKod=null
      },
      Getir(val) {
        this.statesatici = []

        var rec = {
          Aciklama: val.Satici.isim,
          Id: val.Satici.id,
          Kod: val.Satici.kod
        }

        this.islem = 'guncelle'

        this.statesatici.push(rec)


        this.RezervasyonInput.EkliSaticiKod = val.Satici.kod
        this.RezervasyonInput.KDV = val.KDV
        this.silinecekkayit = val.Id
      },
      rezervasyonekiGuncelle() {
        if (this.$refs.formek.validate()) {

          this.RezervasyonInput.SaticiKodu = this.Satici.Kod
          this.RezervasyonInput.SaticiTipi = this.Satici.Tip


          var params = {
            EkliSaticiKod: this.RezervasyonInput.SaticiKodu,
            KDV: this.RezervasyonInput.KDV,
            Id: this.silinecekkayit
          }


          tool.http_post(this, "SaticiEkleriDegistir", params).then(
            response => {

              if (response.body.Status == true) {
                this.islem='yeni'

                this.RezervasyonInput.KDV = 0
                this.RezervasyonInput.EkliSaticiKod = null
                this.loadingacente = false
                var params = {
                  SaticiTipi: this.Satici.Tip,
                  SaticiKodu: this.Satici.Kod
                }


                tool.http_post(this, "SaticiEkleriList", params).then(
                  response => {

                    if (response.body.Status == true) {

                      this.items = response.body.data

                    } else {

                      this.text1 = 'Service Unavailable '
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable '
                    this.snackbar = true
                  }
                );

              } else {
                var str = ''
                response.body.ErrorList.forEach(element => {
                  str += element + ' , '
                });
                this.text1 = str
                this.snackbar = true
                this.loadingacente = false
              }
            },
            response => {
              this.text1 = 'Service Unavailable ara '
              this.snackbar = true
              this.loadingacente = false
            }
          );

        }
      },
      rezervasyonsil(val) {
        this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize eminmisiniz', 1).then(sonuc => {

          if (sonuc == true) {


            var params = {
              Id: val.Id
            }

            tool.http_post(this, "SaticiEkleriSil", params).then(
              response => {

                if (response.body.Status == true) {

                  var params = {
                    SaticiTipi: this.Satici.Tip,
                    SaticiKodu: this.Satici.Kod
                  }


                  tool.http_post(this, "SaticiEkleriList", params).then(
                    response => {

                      if (response.body.Status == true) {

                        this.items = response.body.data

                      } else {

                        this.text1 = 'Service Unavailable list'
                        this.snackbar = true
                      }
                    },
                    response => {

                      this.text1 = 'Service Unavailable lit'
                      this.snackbar = true
                    }
                  );


                } else {
                  var str = ''
                  response.body.ErrorList.forEach(element => {
                    str += element + ' , '
                  });
                  this.text1 = str
                  this.snackbar = true
                }
              },
              response => {
                this.text1 = 'Service Unavailable '
                this.snackbar = true
              }
            );


          }
        });
      },
      rezervasyonekiEkle() {
        if (this.$refs.formek.validate()) {

          this.RezervasyonInput.SaticiKodu = this.Satici.Kod
          this.RezervasyonInput.SaticiTipi = this.Satici.Tip

          var params = this.RezervasyonInput
          tool.http_post(this, "SaticiEkleriEkle", params).then(
            response => {

              if (response.body.Status == true) {

                this.RezervasyonInput.KDV = 0
                this.RezervasyonInput.EkliSaticiKod = null
                this.loadingacente = false
                var params = {
                  SaticiTipi: this.Satici.Tip,
                  SaticiKodu: this.Satici.Kod
                }


                tool.http_post(this, "SaticiEkleriList", params).then(
                  response => {

                    if (response.body.Status == true) {

                      this.items = response.body.data

                    } else {

                      this.text1 = 'Service Unavailable '
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable '
                    this.snackbar = true
                  }
                );

              } else {
                var str = ''
                response.body.ErrorList.forEach(element => {
                  str += element + ' , '
                });
                this.text1 = str
                this.snackbar = true
                this.loadingacente = false
              }
            },
            response => {
              this.text1 = 'Service Unavailable ara '
              this.snackbar = true
              this.loadingacente = false
            }
          );

        }
      },
      saticigetir(ara) {
        var params = {
          SaticiTipi: 10, //Acente
          Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
          Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
          Aciklama: ara //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
        }

        tool.http_post(this, "SimpleSaticiAra", params).then(
          response => {

            if (response.body.Status == true) {
              this.statesatici = response.body.data
              this.loadingacente = false

            } else {
              this.text1 = 'Service Unavailable ara'
              this.snackbar = true
              this.loadingacente = false
            }
          },
          response => {
            this.text1 = 'Service Unavailable ara '
            this.snackbar = true
            this.loadingacente = false
          }
        );



      },
      onay() {
        this.dialog = false
        this.resolve(true);
      },
      iptal() {
        this.resolve(false);
        this.dialog = false
      },


      open(tip, kod) {

        this.Satici.Kod = kod
        this.Satici.Tip = tip


        var params = {
          SaticiTipi: tip,
          SaticiKodu: kod
        }


        tool.http_post(this, "SaticiEkleriList", params).then(
          response => {

            if (response.body.Status == true) {

              this.items = response.body.data

            } else {

              this.text1 = 'Service Unavailable list'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable lit'
            this.snackbar = true
          }
        );

        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        islem: 'yeni',
        silinecekkayit: null,
        Satici: {
          Tip: null,
          Kod: null
        },
        valid: true,
        RezervasyonInput: {
          SaticiKodu: null,
          EkliSaticiKod: null,
          KDV: 0,
          SaticiTipi: null
        },
        loadingsatici: false,
        statesatici: [],
        searchsatici: null,

        headersservis: [{
            text: 'Satıcı Kod',
            value: 'Satici.kod'
          },
          {
            text: this.$t('VAT'),
            value: 'KDV',

          },
          {
            text: '',
            value: '',

          }
        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialog: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {
      searchsatici(val) {
        val && this.saticigetir(val)
      },

    },
  }




  function beforeMount() {



  }
</script>